import { Model } from 'mobx-rest'

// TODO: POST has to be implemented
export class SelectionQuery extends Model {
    urlRoot() {
        return '/selectionQuery';
    }

    url() {
        return this.urlRoot();
    }
}
